import React, { useMemo, Fragment, useEffect } from "react";
import { connect } from "react-redux";

import { get } from "lodash";

import DepositLimitsLib, { MODAL_STATUS } from "@tvg/sh-lib-deposit-limits";
import DepositLimitsTemplate from "@tvg/atomic-ui/_templates/DepositLimits";
import parseCapiMessage from "@tvg/utils/capiUtils";
import {
  rgDepositLimitModalOpen,
  rgSetLoading,
  rgSubmitModalFinished,
  rgCloseModal
} from "@tvg/responsible-gaming-modal/src/actions";
import { getAccountNumber } from "@urp/store-selectors";

export const handleInput = (event, setTargetAmount, setCanSubmit) =>
  DepositLimitsLib.handleInput(event, setTargetAmount, setCanSubmit);

export const updateIndex = (
  newIndex,
  index,
  setPeriod,
  setIndex,
  setTargetAmount,
  setIsActive,
  setCanSubmit,
  setIsComingFromLogin,
  isLogged
) => {
  DepositLimitsLib.updateIndex(
    newIndex,
    index,
    setPeriod,
    setIndex,
    setTargetAmount,
    setIsActive,
    setCanSubmit,
    setIsComingFromLogin,
    isLogged
  );
};

export const toggleActive = (isActive, setIsActive, setTargetAmount) =>
  DepositLimitsLib.toggleActive(isActive, setIsActive, setTargetAmount);

export const toggleNotActive = (
  isActive,
  targetAmount,
  setIsActive,
  setTargetAmount,
  setCanSubmit
) =>
  DepositLimitsLib.toggleNotActive(
    isActive,
    targetAmount,
    setIsActive,
    setTargetAmount,
    setCanSubmit
  );

export const onErrorButtonCallback = () => window.location.reload();

export const DepositLimitsPage = (props) => {
  const DL = DepositLimitsLib.useDepositLimits(props);

  useEffect(() => {
    props.setIsLoading(DL.isLoading);
  }, [DL.isLoading]);
  useEffect(() => {
    switch (DL.modalType) {
      case MODAL_STATUS.CONFIRM:
        props.depositLimitModalOpen(
          DL.limitsInfo.newLimit,
          DL.limitsInfo.applyDate,
          DL.limitsInfo.previousLimit,
          DL.modalConfigs.CONFIRM.primaryButton.callback,
          DL.modalConfigs.CONFIRM.secondaryButton.callback
        );
        break;
      case MODAL_STATUS.SUCCESS:
        props.setModalSuccess(DL.modalConfigs.SUCCESS.secondaryButton.callback);
        break;
      case MODAL_STATUS.ERROR:
        break;
      default:
        // MODAL_STATUS.CLOSED
        props.setModalClose();
    }
  }, [DL.modalType]);
  useEffect(() => {
    if (!props.modalIsOpen && DL.modalType !== MODAL_STATUS.CLOSED)
      DL.setModalType(MODAL_STATUS.CLOSED);
  }, [props.modalIsOpen]);

  const {
    modalMessages,
    depositLimitTitle,
    depositLimitTitleInfo,
    depositLimitSubTitleInfo,
    depositLimitPeriods,
    depositLimitSubmit,
    pendingLimitsConfig
  } = props.depositLimitsPage;

  return useMemo(
    () => (
      <Fragment>
        <DepositLimitsTemplate
          device={props.device}
          hasError={DL.hasError}
          capiMessages={modalMessages}
          onErrorButtonCallback={onErrorButtonCallback}
          isLoading={DL.isLoading}
          index={DL.index}
          indexesApplied={DL.indexesApplied}
          updateIndex={(newIndex) =>
            updateIndex(
              newIndex,
              DL.index,
              DL.setPeriod,
              DL.setIndex,
              DL.setTargetAmount,
              DL.setIsActive,
              DL.setCanSubmit,
              DL.setIsComingFromLogin,
              props.isLogged
            )
          }
          isInputActive={DL.isInputActive}
          toggleInputCallback={DL.setIsInputActive}
          limits={DL.limitsInfo}
          onSubmitClick={DL.onSubmitCallback}
          isActive={DL.isActive}
          canSubmit={DL.canSubmit}
          depositLimitTitle={depositLimitTitle}
          depositLimitTitleInfo={depositLimitTitleInfo}
          depositLimitSubTitleInfo={depositLimitSubTitleInfo}
          depositLimitFooterInfo={
            DL.capiMessagesInstantiated.depositLimitFooterInfo
          }
          depositLimitPeriods={depositLimitPeriods}
          depositLimitSubmit={depositLimitSubmit}
          pendingLimitsConfig={pendingLimitsConfig}
          targetAmount={DL.targetAmount}
          handleInput={(event) =>
            handleInput(event, DL.setTargetAmount, DL.setCanSubmit)
          }
          toggleActive={() =>
            toggleActive(DL.isActive, DL.setIsActive, DL.setTargetAmount)
          }
          toggleNotActive={() =>
            toggleNotActive(
              DL.isActive,
              DL.targetAmount,
              DL.setIsActive,
              DL.setTargetAmount,
              DL.setCanSubmit
            )
          }
          onCleanInputHandler={() =>
            DepositLimitsLib.onCleanInputHandler(
              DL.setTargetAmount,
              DL.setCanSubmit
            )
          }
        />
      </Fragment>
    ),
    [
      DL.index,
      DL.isActive,
      DL.canSubmit,
      DL.targetAmount,
      DL.isInputActive,
      DL.modalType,
      JSON.stringify(DL.limits),
      DL.isLoading,
      DL.hasError,
      props.depositLimitsPage,
      DL.indexesApplied,
      props.isLogged,
      props.accountNumber
    ]
  );
};

DepositLimitsPage.defaultProps = {
  device: "mobile",
  index: 0,
  indexesApplied: [],
  isActive: false,
  canSubmit: false,
  period: "24 hour",
  depositLimitsPage: {
    modalMessages: null,
    depositLimitTitle: "",
    depositLimitTitleInfo: "",
    depositLimitSubTitleInfo: "",
    depositLimitFooterInfo: "",
    depositLimitPeriods: [],
    depositLimitSubmit: {
      title: "",
      placeholder: "",
      buttonText: ""
    },
    pendingLimitsConfig: {
      currentLimitLabel: "",
      pendingLimitLabel: "",
      appliedLabel: "",
      editButtonText: "",
      cancelButtonText: ""
    }
  }
};

export const mapDispatchToProps = (dispatch) => ({
  depositLimitModalOpen: (
    newLimit,
    applyDate,
    previousLimit,
    primaryButtonCallback,
    secondaryButtonCallback
  ) =>
    dispatch(
      rgDepositLimitModalOpen(
        newLimit,
        applyDate,
        previousLimit,
        primaryButtonCallback,
        secondaryButtonCallback
      )
    ),
  setIsLoading: (isLoading) => dispatch(rgSetLoading(isLoading)),
  setModalSuccess: (secondaryButtonCallback) =>
    dispatch(rgSubmitModalFinished(null, secondaryButtonCallback)),
  setModalClose: () => dispatch(rgCloseModal())
});

export default connect(
  (store) => ({
    isLogged: get(store, "userData.logged", false),
    depositLimitsPage: parseCapiMessage(
      store,
      "capi.messages.rgDepositLimitsPage",
      {
        modalMessages: null,
        depositLimitTitle: "",
        depositLimitTitleInfo: "",
        depositLimitSubTitleInfo: "",
        depositLimitFooterInfo: "",
        depositLimitPeriods: [],
        depositLimitSubmit: {
          title: "",
          placeholder: "",
          buttonText: ""
        },
        pendingLimitsConfig: {
          currentLimitLabel: "",
          pendingLimitLabel: "",
          appliedLabel: "",
          editButtonText: "",
          cancelButtonText: ""
        }
      }
    ),
    accountNumber: getAccountNumber(store),
    modalIsOpen: get(store, "modal.responsibleGaming.isOpen", false)
  }),
  mapDispatchToProps
)(DepositLimitsPage);
